<script setup>

</script>

<template>
  <div>
    <div>Customer Operation - Take Order</div>
  </div>
</template>

<style scoped>

</style>
